import * as React from 'react';

import AppState from '@webapp/store/state';
import { Category } from '@common/types/categories/category';
import { TrackLanguage } from '@common/types/release/track-language';
import { connect } from 'react-redux';
import { UpdateTrackField } from '@webapp/store/tracks/action-creators';
import { Dispatch } from 'redux';
import { TrackType } from '@common/types/release/track-type';
import ErrorMessage from '@webapp/components/basics/error-message/index';
import { UpdateReleaseStoreError } from '@webapp/store/release/action-creators';
import LanguageCtrl from '../../language';

interface TrackLanguageCtrlProps {
  id?: string;
  className?: string;
  validate?: boolean;
  trackId: string;
  releaseId?: string;
}

interface StoreProps {
  language?: string;
  isrcExists?: boolean;
  languages: Category<TrackLanguage>[];
  trackType: TrackType;
  onChange: (value: string) => UpdateTrackField<'language'>;
  sendAnalytics: (
    field: string,
    value: string,
    error: string,
    releaseId?: string
  ) => UpdateReleaseStoreError;
}

const mapStateToProps = (state: AppState, props: TrackLanguageCtrlProps) => ({
  language: state.tracks.tracks[props.trackId].language,
  isrcExists: state.tracks.tracks[props.trackId]?.isrcExists,
  trackType: state.tracks.tracks[props.trackId].type || 'song',
  languages: state.categories.lists.language || [],
});

const mapDispatchToProps = (dispatch: Dispatch, props: TrackLanguageCtrlProps) => ({
  onChange: (value: string) =>
    dispatch(
      new UpdateTrackField<'language'>(props.trackId, 'language', value)
    ),
  sendAnalytics: (
    field: string,
    value: string,
    error: string,
    releaseId?: string
  ) => dispatch(new UpdateReleaseStoreError(error, field, value, releaseId)),
});

export const TrackLanguageCtrl: React.FC<TrackLanguageCtrlProps & StoreProps> = ({
  validate,
  releaseId,
  ...props
}) => {
  const { language, sendAnalytics } = props;
  const handleChange = (value: string) => {
    props.onChange(value);
  };

  React.useEffect(() => {
    if (validate && language === undefined) {
      sendAnalytics(
        'Release Language',
        '',
        'RELEASE.MISSING_LANGUAGE',
        releaseId
      );
    }
  }, [validate, releaseId, language, sendAnalytics]);

  return props.trackType === 'instrumental' ? null : (
    <LanguageCtrl
      id={props.id}
      value={props.language}
      onChange={(value) => handleChange(value)}
      disabled={props.isrcExists}
      error={validate && props.language === undefined && (
        <ErrorMessage
          className="mt-5"
          hasBackground
          errorId="RELEASE.MISSING_LANGUAGE"
        />
      )}
    />
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackLanguageCtrl);
